import { render, staticRenderFns } from "./categoriaproductoAdd.vue?vue&type=template&id=0d5520d6&"
import script from "./categoriaproductoAdd.vue?vue&type=script&lang=js&"
export * from "./categoriaproductoAdd.vue?vue&type=script&lang=js&"
import style0 from "./categoriaproductoAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports